import { render, staticRenderFns } from "./PrintCompany.vue?vue&type=template&id=3c6f0a07&scoped=true&"
import script from "./PrintCompany.vue?vue&type=script&lang=js&"
export * from "./PrintCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f0a07",
  null
  
)

export default component.exports